import { PluginInitializerService } from 'core-client/api';
import { OiclOpenbridgeService } from './oicl-openbridge.service';

export function oicOpenbridgeInitializerFactory(
    oiclOpenbridgeService: OiclOpenbridgeService,
    configService: PluginInitializerService
): () => Promise<void> {
    return () =>
        new Promise<void>((resolve) => {
            const init = async () => {
                await oiclOpenbridgeService.setup();
            };

            configService.setup('oiclOpenbridge', init, resolve);
        });
}
